/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:baseline}.close-button[_ngcontent-%COMP%]{cursor:pointer}.container[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;height:calc(100% - 25px);min-height:340px}mat-dialog-content[_ngcontent-%COMP%]{flex-grow:1;padding-top:20px}"];
export { styles as styles };
